import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  get(key: string): string {
    // @ts-ignore
    return window['env']?.[key] || '';
  }
}
